
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/products",
      function () {
        return require("private-next-pages/shop/products/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shop/products"])
      });
    }
  